// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5608) return "static/chunks/5608-1edb96e275086d06.js";
	if (chunkId === 9334) return "static/chunks/9334-3f20346fced2ee02.js";
	if (chunkId === 2505) return "static/chunks/2505-32775a343316b5ce.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 3524 ? "2170a4aa" : chunkId) + "." + {"2188":"50228f934240e435","3524":"02d9a64759bff447","8082":"420aa4bf01b612c8","8436":"cab94b59cca0a8ff","9583":"832911e2d87a9f59"}[chunkId] + ".js";
};